import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AddonList {
  name: string;
  value?: string;
}

interface PopupConfig {
  message: string;
  messageType: "success" | "error" | "warning";
  popupForm: "e-sign" | "normal";
  continueBtnText?: string;
  cancelBtnText?: string;
  addonList?: AddonList[];
  addonListType?: "link" | "text";
  closeBtn?: boolean;
  continueBtnWithLink?: {name: string; link: string};
}

interface ShowPopupPayload {
  popupType: NonNullable<UIState["popupType"]>;
  popupData: PopupConfig;
}

interface UIState {
  popupData: PopupConfig | null;
  popupType: "e-sign" | "normal" | null;
}

const initialState: UIState = {
  popupData: null,
  popupType: null,
};

const popupMessageSlice = createSlice({
  name: "PopupMessage",
  initialState,
  reducers: {
    showPopup: (state, action: PayloadAction<ShowPopupPayload>) => {
      state.popupType = action.payload.popupType;
      state.popupData = action.payload.popupData;
    },
    hidePopup: (state) => {
      state.popupType = null;
      state.popupData = null;
    },
  },
});

export type { PopupConfig, ShowPopupPayload };
export const { showPopup, hidePopup } = popupMessageSlice.actions;
export default popupMessageSlice.reducer;